// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import type { ArticleType } from '../types';
import ArticleMeta from '../../../../internal/ArticleMeta';
import { Columns, BaseColumn } from '../../../../internal/Columns';

type PropType = {|
  articles: Array<ArticleType>,
  columns?: number,
|};

const Articles = ({ articles, columns = 2 }: PropType) => (
  <Columns columns={columns}>
    {articles.map((article, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <BaseColumn image={article.image} alt={article.alt} key={index}>
        <ArticleMeta author={article.author} categories={article.categories} date={article.date} />
        <h3>
          <a href={article.href} className={styles.title}>
            {article.title}
          </a>
        </h3>
      </BaseColumn>
    ))}
  </Columns>
);

export default Articles;
